import LegalPage from "@/components/site/LegalPage";

export default function RefundPolicy() {
  return (
    <LegalPage
      kicker="Refund Policy"
      title="Refund & Returns"
      updated="December 2025"
      sections={[
        {
          heading: "Order Cancellation",
          body: [
            "Orders may be cancelled at no cost before the invoice has been issued and the goods have shipped from our warehouse. To cancel, email order@bandcsystem.com with your order number.",
            "Once goods have shipped, the return terms below apply.",
          ],
        },
        {
          heading: "Return Eligibility",
          body: [
            "Standard stock items may be returned within 30 days of delivery, in original packaging, unused, and in resaleable condition.",
            "Cut-to-length cable, custom-configured equipment (transformers, switchgear, panel builds), medium-voltage devices, and any special-order items are non-returnable unless the item is defective or shipped in error.",
          ],
        },
        {
          heading: "Restocking Fee",
          body: [
            "Standard returns are subject to a restocking fee of 15% of the item value. Freight to return the goods is the buyer's responsibility unless the item is defective or shipped in error, in which case B&C System will cover return freight.",
          ],
        },
        {
          heading: "Defective or Damaged Goods",
          body: [
            "Inspect all deliveries on arrival. Any visible transit damage must be noted on the carrier's delivery receipt and reported to us within 3 business days. Concealed damage or defects must be reported within 10 business days of delivery.",
            "We will arrange replacement, repair, or credit at our discretion for verified defective items.",
          ],
        },
        {
          heading: "Refund Method & Timing",
          body: [
            "Approved refunds are issued to the original payment method within 7–10 business days of us receiving and inspecting the returned goods.",
          ],
        },
        {
          heading: "How to Start a Return",
          body: [
            "Email order@bandcsystem.com with your order number, item(s), quantity, and reason for return. We will issue an RMA (Return Merchandise Authorization) and shipping instructions. Returns received without an RMA may be refused.",
          ],
        },
      ]}
    />
  );
}
